import React, { useRef, useState, useEffect } from "react";
import { Card, CardContent, Alert, AlertTitle, TextField } from "@mui/material";
import Div from "@jumbo/shared/Div/Div";
import { LoadingButton } from "@mui/lab";
import SweetAlert from "app/Common/SweetAlert";
import { ASSET_IMAGES } from "app/utils/constants/paths";
import { Link, useNavigate } from "react-router-dom";
import { getAssetPath } from "app/utils/appHelpers";
import { alpha } from "@mui/material/styles";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";
import RefreshIcon from "@mui/icons-material/Refresh";
import Stack from "@mui/material/Stack";
import { dispatch } from "app/store/store";
import { useSelector } from "react-redux";
import { forgotPasswordThunk } from "app/store/slice/login-slice";
import { unwrapResult } from "@reduxjs/toolkit";
import { Parser } from "html-to-react";
const ForgotPassword = () => {
  const ToastRef = useRef();
  const navigate = useNavigate();
  const { forgotPasswordLoader } = useSelector((state) => state.LoginReducer);
  const [userData, setUserData] = useState({
    username: { value: "", error: false },
    captcha: { value: "", error: false },
  });
  const [isSentMail, setIsSentMail] = useState(false);
  const [resMessage, setResMessage] = useState("");

  const currentDomain = window.location.hostname;
  let loginBackgroundImage = "";
  if (currentDomain.indexOf("adfuel.us") != -1) {
    loginBackgroundImage = ASSET_IMAGES + "/Login_Background_adfuel.png";
  } else if (currentDomain.indexOf("contextnetworks.net") != -1) {
    loginBackgroundImage = ASSET_IMAGES + "/Login_Background_context.png";
  } else if (currentDomain.indexOf("savvydsp.com") != -1) {
    loginBackgroundImage = ASSET_IMAGES + "/savvy_media.png";
  } else if (currentDomain.indexOf("perfectaudience.io") != -1) {
    loginBackgroundImage = ASSET_IMAGES + "/Perfect_Audience.png";
  } else if (currentDomain.indexOf("arrowmarketinglabs.com") != -1) {
    loginBackgroundImage = ASSET_IMAGES + "/arrow_marketing.png";
  } else {
    loginBackgroundImage = ASSET_IMAGES + "/Login_Background.jpg";
  }

  useEffect(() => {
    loadCaptchaEnginge(6, "#ccc", "black");
  }, []);
  const resetCaptcha = () => {
    loadCaptchaEnginge(6, "#ccc", "black");
    setUserData((prevState) => {
      return {
        ...prevState,
        captcha: { ...prevState.captcha, value: "", error: false },
      };
    });
  };
  const submitForm = () => {
    if (validateForm()) {
      // Call API to send email
      const url = window.location.href;
      const parsedUrl = new URL(url);
      const hostname = parsedUrl.origin;
      const userName = userData?.username?.value;

      dispatch(forgotPasswordThunk({ username: userName, hostname: hostname }))
        .then(unwrapResult)
        .then((res) => {
          if (res.data.success == true) {
            let resultData = res.data;
            setResMessage(resultData?.message);
            setIsSentMail(true);
          } else {
            ToastRef.current.showSweetAlerts("error", res.data.message);
          }
        });
    }
  };
  const validateForm = () => {
    let isValid = true;
    let formInfo = JSON.parse(JSON.stringify(userData));

    if (
      formInfo.username?.value == "" ||
      formInfo.username?.value == null ||
      formInfo.username?.value == undefined
    ) {
      isValid = false;
      formInfo.username.error = true;
    }
    if (
      formInfo.captcha?.value == "" ||
      formInfo.captcha?.value == null ||
      formInfo.captcha?.value == undefined ||
      !validateCaptcha(formInfo.captcha?.value, false)
    ) {
      isValid = false;
      formInfo.captcha.error = true;
    }
    if (!isValid) {
      setUserData(formInfo);
    }
    return isValid;
  };
  const cancelHandler = () => {
    navigate("/login");
  };
  return (
    <Div
      sx={{
        width: 720,
        maxWidth: "100%",
        margin: "auto",
        p: 4,
      }}
    >
      <Card
        sx={{
          display: "flex",
          minWidth: 0,
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <CardContent
          sx={{
            minHeight: "300px",
            flex: "0 1 300px",
            position: "relative",
            background: `${
              currentDomain.indexOf("contextnetworks.net") != -1
                ? "#000"
                : currentDomain.indexOf("savvydsp.com") != -1
                ? "#ffffff"
                : currentDomain.indexOf("arrowmarketinglabs.com") != -1
                ? "#ffffff"
                : currentDomain.indexOf("perfectaudience.io") != -1
                ? "#ffffff"
                : "#0267a0"
            } url(${getAssetPath(
              loginBackgroundImage,
              "640x428"
            )}) no-repeat center`,
            backgroundSize:
              currentDomain.indexOf("contextnetworks.net") != -1 ||
              currentDomain.indexOf("savvydsp.com") != -1 ||
              currentDomain.indexOf("arrowmarketinglabs.com") != -1 ||
              currentDomain.indexOf("perfectaudience.io") != -1
                ? "contain"
                : "cover",

            "&::after": {
              display: "inline-block",
              position: "absolute",
              content: `''`,
              inset: 0,
              backgroundColor:
                currentDomain.indexOf("adfuel.us") != -1 ||
                currentDomain.indexOf("contextnetworks.net") != -1 ||
                currentDomain.indexOf("savvydsp.com") != -1 ||
                currentDomain.indexOf("arrowmarketinglabs.com") != -1 ||
                currentDomain.indexOf("perfectaudience.io") != -1
                  ? "transparent"
                  : alpha("#0267a0", 0.65),
            },
          }}
        >
          <Div
            sx={{
              display: "flex",
              minWidth: 0,
              flex: 1,
              flexDirection: "column",
              color: "common.white",
              position: "relative",
              zIndex: 1,
              height: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Div
              sx={{
                display:
                  currentDomain.indexOf("advangelists.com") != -1 ? "" : "none",
              }}
            >
              <Link href="#" underline="none" sx={{ display: "inline-flex" }}>
                <img
                  src={`${ASSET_IMAGES}/newlogo_white.png`}
                  alt="Mobiquity React"
                  height="50px"
                />
              </Link>
            </Div>
          </Div>
        </CardContent>
        <CardContent sx={{ flex: 1, p: 4, minHeight: "300px" }}>
          {isSentMail && (
            <Alert severity="success">{Parser().parse(resMessage)}</Alert>
          )}
          {!isSentMail && (
            <>
              <Div sx={{ mb: 2, textAlign: "center", fontSize: "20px" }}>
                Forgot Password
              </Div>
              <Div sx={{ mt: 1, mb: 3 }}>
                <TextField
                  fullWidth
                  label="Username"
                  placeholder="Enter Username"
                  value={userData?.username?.value}
                  onChange={(e) => {
                    setUserData((prevState) => {
                      return {
                        ...prevState,
                        username: {
                          ...prevState.username,
                          value: e.target.value,
                          error: false,
                        },
                      };
                    });
                  }}
                  error={userData?.username?.error}
                  helperText={
                    userData?.username?.error ? "Please enter username." : ""
                  }
                />
              </Div>
              <Stack direction="row" useFlexGap flexWrap="wrap">
                <LoadCanvasTemplateNoReload />
                <RefreshIcon
                  onClick={() => {
                    resetCaptcha();
                  }}
                  sx={{ ml: 2, mt: "3px", cursor: "pointer" }}
                />
              </Stack>
              <Div sx={{ mt: 1, mb: 2 }}>
                <TextField
                  fullWidth
                  label="Enter Captcha"
                  placeholder="Enter above captcha"
                  id="input_captcha"
                  value={userData?.captcha?.value}
                  onChange={(e) => {
                    setUserData((prevState) => {
                      return {
                        ...prevState,
                        captcha: {
                          ...prevState.captcha,
                          value: e.target.value,
                          error: false,
                        },
                      };
                    });
                  }}
                  error={userData?.captcha?.error}
                  helperText={
                    userData?.captcha?.error
                      ? "Please enter valid captcha."
                      : ""
                  }
                />
              </Div>
              <Div sx={{ flexDirection: "row" }}>
                <LoadingButton
                  //type="submit"
                  variant="contained"
                  onClick={submitForm}
                  size="medium"
                  sx={{ mr: 2, width: "48%" }}
                  loading={forgotPasswordLoader}
                >
                  Submit
                </LoadingButton>
                <LoadingButton
                  variant="outlined"
                  size="medium"
                  onClick={cancelHandler}
                  sx={{ width: "45%" }}
                >
                  Cancel
                </LoadingButton>
              </Div>
            </>
          )}
        </CardContent>
      </Card>
      <SweetAlert ref={ToastRef} />
    </Div>
  );
};

export default ForgotPassword;
